import { useMutation } from "@tanstack/react-query";
import uploadsApiClient, { UploadFileInput } from "../../../api/uploads";

const useUploadStrikeMutation = () => {
  return useMutation({
    mutationFn: (input: UploadFileInput) =>
      uploadsApiClient.uploadStrike(input),
  });
};

export default useUploadStrikeMutation;
